<template lang="pug">
.sheet
  span.label {{productSheet.label}}
  ProductSheetDrawing(:products="products")
  .info
    MouserProductSheetSpecs(
      :products="products",
      :notes="productSheet.notes")
    ProductSheetStamp(
      :logo="productSheet.logo",
      :address="productSheet.address",
      :title="title",
      :configID="configID")
</template>
<script>
import ProductSheetDrawing from "@/components/configuration/ProductSheetDrawing";
import MouserProductSheetSpecs from "@/components/configuration/MouserProductSheetSpecs";
import ProductSheetStamp from "@/components/configuration/ProductSheetStamp";

import {mapGetters} from 'vuex';

export default {
  name: "ProductSheet",
  props: ["products", "title", "configID", "address"],
  components: {
    ProductSheetDrawing,
    MouserProductSheetSpecs,
    ProductSheetStamp
  },
  computed: {
    ...mapGetters(['productSheet'])
  }
};
</script>


<style lang="scss" scoped>
.sheet {
  display: flex;
  flex-direction: column;
  border: 1px solid $lightGray;
  border-radius: 3px;
}

.label {
  font-size: 0.6875rem;
  padding: 0.3875rem 0.5rem;
  border-right: 1px solid $lightGray;
  border-bottom: 1px solid $lightGray;
  border-radius: 0 0 3px 0;
  align-self: flex-start;
  text-transform: uppercase;
  letter-spacing: 1.25px;
}

.info {
  display: flex;
  flex-direction: column;
  @include mq(md, $print: true) {
    flex-direction: row;
  }
}
</style>